export default {
  messages: {
    uk: {
      'Дякую! Ваша заявка на виїзну перевірку прийнята': 'Дякую! Ваша заявка на виїзну перевірку прийнята',
      'Найближчим часом з Вами звʼяжеться менеджер AUTO.RIA для уточнення деталей': 'Найближчим часом з Вами звʼяжеться менеджер AUTO.RIA для уточнення деталей',
    },
    ru: {
      'Дякую! Ваша заявка на виїзну перевірку прийнята': 'Спасибо! Ваша заявка на выездную проверку принята',
      'Найближчим часом з Вами звʼяжеться менеджер AUTO.RIA для уточнення деталей': 'В ближайшее время с Вами свяжется менеджер AUTO.RIA для уточнения деталей',
    },
  },
};
